export const EVENT_TERMS_INTRO =
  "Event registration policy for the Support Muslim Business Forum Ltd. (SMBF). This policy applies to all events hosted by SMBF and is designed to ensure a smooth and professional experience for all participants. Please read the following terms carefully before registering for any of our events.";

export const EVENT_TERMS_SECTIONS: { title: string; body: string }[] = [
  {
    title: "1. Event Registration",
    body:
      "Registrations for our events can be completed through our official websites, smbf.global or smbf.org.uk. Upon successful registration and payment, you will receive a confirmation email containing your event details. Please ensure all information provided during registration is accurate, as registrations are non-transferable.",
  },
  {
    title: "2. Payment Methods",
    body:
      "We accept various payment methods, including major credit and debit cards. All transactions are processed securely to protect your personal information.",
  },
  {
    title: "3. Non-Refundable Policy",
    body:
      "Please note that all registrations are final. Payments are non-refundable under any circumstances. This policy is in place to cover the costs associated with event planning and preparation.",
  },
  {
    title: "4. Event Cancellation or Rescheduling",
    body:
      "In the unlikely event that an SMBF event is cancelled or rescheduled, you will be notified as soon as possible. If the event is cancelled, a full refund will be issued. If the event is rescheduled, your registration will be valid for the new date. Should you be unable to attend the rescheduled date, please contact us for further assistance.",
  },
  {
    title: "5. Registration Transfer",
    body:
      "Registrations are non-transferable. Each registration is valid only for the individual whose name is on the registration form. Please bring a valid photo ID to the event for verification purposes.",
  },
  {
    title: "6. Entry Requirements",
    body:
      "We may ask for a photo ID at the event during registration that matches the name and address you used to book your registration.",
  },
  {
    title: "7. Code of Conduct",
    body:
      "All attendees are expected to behave in a professional and respectful manner. Any form of harassment or disruptive behaviour will not be tolerated and may result in removal from the event without a refund.",
  },
  {
    title: "8. Liability",
    body:
      "The organisers are not responsible for any personal injury, loss, or damage to personal property during the event. Attendees participate at their own risk.",
  },
  {
    title: "9. Contact Information",
    body:
      "For any questions or concerns regarding registrations or the event, please contact our support team at enquiries@smbf.global or 0121 357 6786.",
  },
];

export const EVENT_TERMS_CLOSING =
  "By registering for an SMBF event, you agree to comply with all terms and conditions outlined in this policy. Thank you for your cooperation and understanding. We look forward to seeing you at the event!";
